import { render, staticRenderFns } from "./SelectArrow.vue?vue&type=template&id=39817709&"
import script from "./SelectArrow.vue?vue&type=script&lang=js&"
export * from "./SelectArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports